//requires: public\pclm-map-helper.js

var markerManager={
		
		_markers_layers : {},
		_eventManager: eventManager,
		_selectionStyle: {color: "#ff7800", weight: 1},
		
		
		init: function(){
			
			var mapsHtmlId = mapsManager.searchMapOnPage(mapsManager.get_map_id_prefix());
			
			this._behaviours = new L.Behaviours();
			
			mapsHtmlId.each(function() {
				jQuery.get({
					url:pclm_ajax_object.ajaxurl,
					data:{	
						"nonce": pclm_ajax_object.nonce_markers_data,
						"action":"markers_data",
						"id": this.id 
					},
					context: markerManager,
					dataType: 'json',
					success:	function(data){
						// For every marker got from db
						for (var markersIdx in data.markers){
							
							var leafletData = JSON.parse(data.markers[markersIdx]['leaflet_data']);
							var leafletDataProperties =  leafletData['properties'];
							var leafletDataOptions =  leafletData['options'];
							
							var icon = markerManager.icon.create(leafletDataOptions);
													
							var marker = L.marker(leafletDataProperties['position'],leafletDataOptions);
							
							if (icon!= false){
								marker.setIcon(icon);
							}

							var postData = data.markers[markersIdx]['post'];
							
							marker.publication.setPostId(postData['ID']);
							marker.publication.setParent(postData['post_parent']);
							marker.publication.setStatut(postData['post_status']);
							marker.publication.setDate(postData['post_date']);
							marker.publication.setDateGMT(postData['post_date_gmt']);
							//marker.publication.setVisibility(postData['post_visibility']);
							marker.publication.setPassword(postData['post_password']);
							
							if (data.markers[markersIdx]['behaviours']){
								var behavioursData = JSON.parse(data.markers[markersIdx]['behaviours']);
								markerManager._behaviours.setBehaviours(marker,behavioursData);
							}
							
							markerManager.addToFeaturesGroup(marker);
							
						}

					}
				});
			});
		},
		
		
		addMarker: function(mapId, marker){
			if((marker!= null) && (mapId != -1)){
				marker.publication.setParent(mapId.replace(mapsManager.get_map_id_prefix()+'-',''));
				//var enhancedContent = L.enhancedContent(L.EnhancedContent.None.TYPE);
//				enhancedContent.setModalHtmlId('#marker-info-'+ mapsManager.getMapHtmlId(marker.publication.getParent()));
				//marker.bindEnhancedContent(enhancedContent);
				
				this._behaviours.setBehaviours(marker,{'onClick':{type: "none",'options':{}},'onOver':{type: "none",'options':{}}});
				markerManager.addToFeaturesGroup(marker);
				
			}
		},
		
		updateMarker: function(marker, options){
			
			var icon = markerManager.icon.create(options);
			
			var newMarker = L.marker(marker.getLatLng(),options);
			newMarker.bindPublication(marker.publication);
			if(icon!=false){
				newMarker.setIcon(icon);
			}
			markerManager.updateFeatureGroup(marker,newMarker);
			this._behaviours.setBehaviours(newMarker, this._behaviours.getBehaviours(marker));
			
		},
		
		initFeatureGroup:function(mapId){
			if (L.markerClusterGroup && !mapsManager.checkDrawCapabilities(mapId)){
				markerManager._markers_layers[mapId] = new L.markerClusterGroup();
			}else{
				markerManager._markers_layers[mapId] = new L.FeatureGroup();
			}
			
			var returnedLayer  = mapsManager.setLayer(mapId,markerManager._markers_layers[mapId]);
		},
		
		getFeaturesGroup: function(mapId){
			
			var mapId = mapId || null;
			// if no mapId return all markers
			if (mapId==null){
				return markerManager._markers_layers;
			}else{
				var mapHtmlId = mapsManager.getMapHtmlId(mapId);
				// if mapId return the corresponding markers group
				if (!markerManager._markers_layers[mapHtmlId]){
					//init group if don't exist
					markerManager.initFeatureGroup(mapHtmlId);
					return markerManager._markers_layers[mapHtmlId];
				}else{
					return markerManager._markers_layers[mapHtmlId];
				}
				
			}
		},
		
		addToFeaturesGroup: function(layer){
			layer.isDisplayAllowed= function(){return true};
			markerManager.getFeaturesGroup(layer.publication.getParent()).addLayer(layer);
		},
		
		updateFeatureGroup: function(oldLayer,newLayer){
			if (oldLayer.editing){oldLayer.editing.disable();}
			
			var mapId = oldLayer._map.getContainer().id;
			var toReEnable = false;
			var editMode = mapsManager.getDrawManager(mapId).getDrawControls(mapId)._toolbars['edit']._modes['edit'];
			if (editMode.handler._enabled){
				editMode.handler.disable();
				toReEnable=true;
			}
			markerManager.getFeaturesGroup(oldLayer.publication.getParent()).removeLayer(oldLayer);
			markerManager.addToFeaturesGroup(newLayer);
			if (toReEnable){
				editMode.handler.enable();
			}
		},
		
		setDrawMode: function(mapId){
			var featureGroup = markerManager.getFeaturesGroup(mapId);
			featureGroup.eachLayer(function(layer){
				markerManager.setLayerDrawMode(layer);
			});
		},
		
		unsetDrawMode: function(mapId){
			var featureGroup = markerManager.getFeaturesGroup(mapId);
			featureGroup.eachLayer(function(layer){
				markerManager.unsetLayerDrawMode(layer);
			});
		},
		
		setLayerDrawMode: function(layer){
			markerManager.manageSuspendOpening(layer, true);
		},
		
		unsetLayerDrawMode: function(layer){
			markerManager.manageSuspendOpening(layer,false);
		},
		
		manageSuspendOpening: function(layer, suspendStatus){
			layer.suspendModalOpening(suspendStatus);
			layer.suspendPopupOpening(suspendStatus);
			layer.suspendLinkOpening(suspendStatus);
		},
		
		handleEvents : function(e){
				this.init();
		},
		
		registerForEvents : function (element){
			markerManager._eventManager.register(element);
		},
		
		icon: {
			
			_options:['iconUrl','iconRetinaUrl','iconSize','iconAnchor','popupAnchor','tooltipAnchor','shadowUrl','shadowRetinaUrl','shadowSize','shadowAnchor','className','html','bgPos'],
			
			create: function(options){
				var icon =false;
				
				var iconOptions={};
				
				for (var optionIdx in markerManager.icon._options){
					if(options.hasOwnProperty(markerManager.icon._options[optionIdx])){
						
						if ((optionIdx ==0)&&(markerManager.icon.isJsonString(options[markerManager.icon._options[optionIdx]]))){
							iconOptions[markerManager.icon._options[optionIdx]]= JSON.parse(options[markerManager.icon._options[optionIdx]]).url;
						}else{
							iconOptions[markerManager.icon._options[optionIdx]]= options[markerManager.icon._options[optionIdx]];
						}
						
						
						delete options[markerManager.icon._options[optionIdx]];
					}	
				}
				
				if (iconOptions.hasOwnProperty('iconUrl')){
					if (iconOptions.hasOwnProperty('html') || iconOptions.hasOwnProperty('bgPos')){				
						icon = L.divIcon(iconOptions);
					}else{
						icon = L.icon(iconOptions);
					}
				}
				
				return icon;
			},
		
			isJsonString: function(str) {
			    try {
			        JSON.parse(str);
			    } catch (e) {
			        return false;
			    }
			    return true;
			}
		}
		
};

jQuery(document).ready(function($){
	mapsManager.registerForEvents(markerManager);
});